import { Cell } from '@table-library/react-table-library/table';

export const COLUMNS = (onSelect) => [
    {
        label: 'Email',
        key: 'email',
        data: 'email',
        Component: Cell,
        sortType: 'string',
        cellSize: 'minmax(120px, 1fr)',
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <strong className="d-flex align-items-center">
                    <input
                        className="css-e0dnmk"
                        type="checkbox"
                        style={{ marginRight: '10px' }}
                        onChange={() => onSelect(item.email)}
                        checked={item.is_active}
                        id={item.email}
                    />
                    <label htmlFor={item.email}>{data}</label>
                </strong>
            );
        },
    },
];
